import { AxisType, Channel } from '@lmt/signal-viewer-ui';

export enum EventType {
  eSO = '1',
  oA = '101',
  oH = '111',
  uA = '108',
  cA = '102',
  cH = '112',
  eS = '4',
}

enum ChannelType {
  Pressure = '1',
  RespFlow = '2',
  Leak = '6',
}

export default ChannelType;

export const ChannelSpecs: Channel[] = [
  {
    id: ChannelType.Pressure,
    configuration: {
      name: 'Airway Pressure',
      relativeHeight: 18,
      tickInterval: { start: 0, end: 30, step: 5 },
      axisType: AxisType.SignalsWithEvents,
    },
    signals: [
      {
        type: 'Airway Pressure',
        config: { label: 'Airway Pressure', color: '#444' },
      },
      {
        type: 'IPAPsoll',
        config: { label: 'IPAPsoll', color: '#446CAB' },
      },
      {
        type: 'EPAPsoll',
        config: { label: 'EPAPsoll', color: '#D17D7D' },
      },
    ],
    events: [],
  },
  {
    id: ChannelType.RespFlow,
    configuration: {
      name: 'Patient Flow',
      relativeHeight: 16,
      tickInterval: { start: -100, end: 100, step: 50 },
      axisType: AxisType.SignalsWithEvents,
    },
    signals: [
      {
        type: 'Patient Flow',
        config: { label: 'Patient Flow', color: '#00AEEF' },
      },
    ],
    events: [],
  },
  {
    id: ChannelType.Leak,
    configuration: {
      name: 'Volume Signals',
      relativeHeight: 10,
      tickInterval: { start: -100, end: 100, step: 30 },
      axisType: AxisType.SignalsWithEvents,
    },
    signals: [
      {
        type: 'Minute Volume',
        config: { label: 'Minute Volume', color: '#B200FF' },
      },
    ],
    events: [],
  },
];
